import { Component, inject, OnInit } from "@angular/core";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from "@angular/router";
import { ProgressBarComponent } from "@kernel/shared/modules/spinner/components/progress-bar/progress-bar.component";
import { Toast } from "primeng/toast";
import { NgHttpLoaderComponent, SpinnerVisibilityService } from "ng-http-loader";
import { TranslateModule } from "@ngx-translate/core";
import { AuthServiceImpl } from "@app/shared/authentication/services/auth.servcice";
import { EAccessType } from "@app/shared/authentication/enums/access-type.enum";
import { SubscriptionService } from "@app/shared/payment/services/subscription.service";
import { CreditService } from "@app/shared/payment/services/credit.service";
import { SwapRequestService } from "@app/shared/swap-request/services/swap-request.service";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  imports: [RouterOutlet, Toast, NgHttpLoaderComponent, TranslateModule],
  providers: [],
})
export class AppComponent implements OnInit {
  progressBar = ProgressBarComponent;
  private router = inject(Router);
  private authService = inject(AuthServiceImpl);
  private subscriptionService = inject(SubscriptionService);
  private creditService = inject(CreditService);
  public swapRequestService = inject(SwapRequestService);

  constructor(private loader: SpinnerVisibilityService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loader.show();
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.loader.hide();
      }
    });
  }

  ngOnInit() {
    if (this.authService.getUser() && (this.authService.getCurrentTokenType() ?? "") == EAccessType.FAT) {
      this.subscriptionService.loadActiveSubscription().subscribe();
      this.creditService.loadMyCreditBalanceDetails().subscribe();
      this.swapRequestService.loadMySwapRequest().subscribe();
    }
  }
}
